/**
 * @Office hour switcher
 * Automatically switches the content of the office hours
 * During a certain time frame.
 */
var office_switcher = {

  switch: function() {

    var content = $('.office');
    var currentContent = 'OFFICE HOURS: 8am - 5pm MON-FRI';
    var futureContent = 'Customer Care open 28th - 30th December - 10.00 - 16.00';
    var startDate = '28 12 2016'; // date effective from
    var endDate = '31 12 2016'; // we know its only for this month, so we wont go too in depth

    var date = new Date();
    var day = date.getDate(),
      month = date.getMonth(),
      year = date.getFullYear();

    // get current date
    var currentDate = day + ' ' + month + ' ' + year;

    // if current date match future date we set the cookie.
    if ((currentDate === endDate)) {

      // expire the cookie
      document.cookie = 'Cust=false;';

    } else if ((currentDate === startDate)) {

      // set a cookie with an expiry date
      document.cookie = 'Cust=true;';

    }

    // get cookie value
    var customHours = this.getCookie('Cust');

    if (customHours === 'true') {
      // switch the date
      this.switchDate(futureContent, content);
    }

  },

  switchDate: function(dateContent, obj) {

    $(obj).text(dateContent);
    $(obj).css('width', '415px');

  },

  getCookie: function(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2)
      return parts.pop().split(";").shift();
    }

};

module.exports = office_switcher;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/office-hour-switch.js
// module id = 268
// module chunks = 1